import React, { memo, useCallback } from 'react';

import { Box, IconButton, Tooltip } from '@mui/material';
import { ClockIcon, InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { TaskStatus } from 'constants/tasks';

import { TasksTestIds } from '../Tasks.testIds';

import { iconButtonStyles, wrapperStyles } from './TaskHistoryCell.styles';

const TaskHistoryCell = ({ task, status, onOpenHistory, onOpenSlaGroupInfo }) => {
  const openHistory = useCallback(event => onOpenHistory(event, task), [onOpenHistory, task]);

  const openSlaGroupInfo = useCallback(
    event => onOpenSlaGroupInfo(event, task),
    [onOpenSlaGroupInfo, task],
  );

  return (
    <Box sx={wrapperStyles}>
      {!!task.slaGroupId && (
        <Tooltip title="SLA Group Info">
          <IconButton
            data-testid={TasksTestIds.TASK_TABLE_ROW_SLA_INFO_BUTTON}
            size="small"
            sx={iconButtonStyles}
            onClick={openSlaGroupInfo}
          >
            <InfoIcon size={IconSize[20]} />
          </IconButton>
        </Tooltip>
      )}
      {status !== TaskStatus.NEW && (
        <Tooltip title="Show history">
          <IconButton
            data-testid={TasksTestIds.TASK_TABLE_ROW_HISTORY_BUTTON}
            size="small"
            sx={iconButtonStyles}
            onClick={openHistory}
          >
            <ClockIcon size={IconSize[20]} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

TaskHistoryCell.propTypes = {
  status: PropTypes.string.isRequired,
  task: PropTypes.object.isRequired,
  onOpenHistory: PropTypes.func.isRequired,
  onOpenSlaGroupInfo: PropTypes.func.isRequired,
};

export default memo(TaskHistoryCell);
